import { useMemo, memo } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';

function SectionE() {
    const { t } = useLang('theProduct.SectionE');

    const products = useMemo(
        () => [
            {
                image: 'https://websiteoss.ecoflow.com/upload/image/1762152914899/Sectione_1.png',
                title: t('item1_title'),
                desc: [t('item1_desc1'), t('item1_desc2'), t('item1_desc3')],
                link: `https://jp.ecoflow.com/cart/52234748395887:1?channel=buy_button`,
            },
            {
                image: 'https://websiteoss.ecoflow.com/upload/image/1762152914796/Sectione_2.png',
                title: t('item2_title'),
                desc: [t('item2_desc1'), t('item2_desc2'), t('item2_desc3')],
                link: `https://jp.ecoflow.com/cart/52234754785647:1?channel=buy_button`,
            },
        ],
        [t],
    );

    return (
        <div className={`${styles.SectionE} eco-content GtmModuleData-section RV-sectionE`} id="RV-SectionE" data-section-id="on-the-road-SectionE">
            <EcoSpace />

            <div className="products">
                {products.map((product, index) => (
                    <div key={index} className="product-card">
                        <div className="product-image">
                            <EcoImg pc={product.image} h5={product.image} isOpenLazy />
                        </div>
                        <div className="product-content">
                            <h3 className="product-title">{product.title}</h3>
                            <div className="product-desc">
                                {product?.desc?.map((item) => (
                                    <span key={item}>{item}</span>
                                ))}
                            </div>
                            <EcoLink
                                href={product.link}
                                className={`product-link card-${index + 1} GtmModuleData-btn-href`}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'checkout',
                                    button_name: `${t('item_btn')}_${product.title}`,
                                    __btn_id1: `RV-sectionE .card-${index + 1}`,
                                    __btn_id2: product.link,
                                    __btn_type: 'href',
                                }}
                            >
                                {t('item_btn')}
                            </EcoLink>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default memo(SectionE);
